/**
 * Domains that third-party scripts injected into the page (by a browser
 * add-on or survey panel on the user's machine, not by this app) send their
 * own telemetry to. Those requests go through `window.fetch`, which the
 * Datadog Logs SDK patches, so a failed one is reported as a network error
 * log even though no Marble code made it.
 *
 * A host matches when it is the domain itself or any subdomain of it.
 *
 * - **disqometer.com** – `scripts.api.disqometer.com/desktop_inpage_script.js`
 *   posts to `scripts.api.disqometer.com/v2/logs`.
 */
export const THIRD_PARTY_TELEMETRY_DOMAINS = ["disqometer.com"];

/**
 * The message the Logs SDK gives a network-origin log, e.g.
 * `Fetch error POST https://scripts.api.disqometer.com/v2/logs`. Used to
 * recover the URL when the log carries no `http.url`.
 */
export const NETWORK_LOG_MESSAGE_PATTERN = /^(?:Fetch|XHR) error [A-Z]+ (\S+)/;
